import Vue from 'vue';

import VBlackerTheme, { VBlackerThemeProvider } from 'v-blacker-theme';

import { createRouter } from '@router';

import store from '@store';

import App from './App.vue';

import UmsPasswordField from './components/UmsPasswordField.vue';
import UmsPasswordChangeActivator from './components/UmsPasswordChangeActivator.vue';
import UmsStatusBadge from './components/UmsStatusBadge.vue';

Vue.config.productionTip = false;

Vue.use(VBlackerTheme);

Vue.component('ums-password-field', UmsPasswordField);
Vue.component('ums-password-change-activator', UmsPasswordChangeActivator);
Vue.component('ums-status-badge', UmsStatusBadge);

const router = createRouter();

const app = new Vue({
  store,
  router,
  ...VBlackerThemeProvider,
  render: (h) => h(App),
});

router.onReady(() => app.$mount('#app'));
